import React from 'react';

import * as userService from '../../services/user/User';

const UserContext = React.createContext();
const { Provider, Consumer } = UserContext;

class UserProvider extends React.Component {
  state = {
    response: null,
  };

  constructor(props) {
    super(props);
    this.signIn = this.signIn.bind(this);
    this.signOut = this.signOut.bind(this);
    this.currentUser = this.currentUser.bind(this);
    this.changePassword = this.changePassword.bind(this);
    this.passwordResetRequest = this.passwordResetRequest.bind(this);
    this.passwordReset = this.passwordReset.bind(this);
    this.profileUpdate = this.profileUpdate.bind(this);
    this.emailVerify = this.emailVerify.bind(this);
  }

  async signIn(data, onSuccess) {
    return new Promise(async (resolve, reject) => {
      await userService
        .signIn(data, onSuccess)
        .then(res => {
          resolve(res);
        })
        .catch(res => {
          reject(res);
        });
    });
  }

  async signOut() {
    return new Promise(async resolve => {
      await userService.signOut().then(res => {
        resolve(res);
      });
    });
  }

  async currentUser() {
    return new Promise(async (resolve, reject) => {
      await userService
        .currentUser()
        .then(res => {
          resolve(res);
        })
        .catch(res => {
          reject(res);
        });
    });
  }

  async emailVerify(data) {
    return new Promise(async (resolve, reject) => {
      await userService
        .emailVerify(data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  async profileUpdate(data) {
    return new Promise(async (resolve, reject) => {
      await userService
        .profileUpdate(data)
        .then(res => {
          resolve(res);
        })
        .catch(res => {
          reject(res);
        });
    });
  }

  async changePassword(data) {
    return new Promise(async (resolve, reject) => {
      await userService
        .changePassword(data)
        .then(res => {
          resolve(res);
        })
        .catch(res => {
          reject(res);
        });
    });
  }

  async passwordResetRequest(data) {
    return new Promise(async (resolve, reject) => {
      await userService
        .passwordResetRequest(data)
        .then(res => {
          resolve(res);
        })
        .catch(res => {
          reject(res);
        });
    });
  }

  async passwordReset(data) {
    return new Promise(async (resolve, reject) => {
      await userService
        .passwordReset(data)
        .then(res => {
          resolve(res);
        })
        .catch(res => {
          reject(res);
        });
    });
  }

  render() {
    const { children } = this.props;

    return (
      <Provider
        value={{
          response: this.state.response,
          signIn: this.signIn,
          signOut: this.signOut,
          changePassword: this.changePassword,
          currentUser: this.currentUser,
          profileUpdate: this.profileUpdate,
          passwordResetRequest: this.passwordResetRequest,
          passwordReset: this.passwordReset,
          emailVerify: this.emailVerify,
        }}
      >
        {children}
      </Provider>
    );
  }
}

export default UserContext;

export { UserProvider, Consumer };
